<template>
  <Transition name="fade">
    <div v-if="isRouteLoading" class="route-loading-bar">
      <div 
        class="route-loading-progress" 
        :style="{ width: `${loadingProgress}%` }"
      ></div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { useRouteLoading } from '@/composables/useRouteLoading';

const { isRouteLoading, loadingProgress } = useRouteLoading();
</script>

<style scoped>
.route-loading-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: rgba(82, 113, 255, 0.1);
  z-index: 9999;
  overflow: hidden;
}

.route-loading-progress {
  height: 100%;
  background: linear-gradient(90deg, #5271FF 0%, #764BA2 100%);
  transition: width 0.3s ease;
  box-shadow: 0 0 10px rgba(82, 113, 255, 0.5);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
